<div class="container-fluid">
  <app-content-tab-list activeTab="2" type="cms" category="CMS"></app-content-tab-list>
  <div class="row section1 mt-4">
    <div class="col-12 col-md-7 col-lg-7 col-xl-7">
      <div class="home-details">
        <h5 class="home-title">NFT Collections</h5>
        <p class="home-subtitle">List of all colletions</p>
      </div>
    </div>
    <div class="col-12 col-md-7 col-lg-5 col-xl-5">
      <div class="dashboard-btn dashboard-manage">
        <div>
          <a routerLink="/nfts/create-collection">
            <button class="btn btn-primary btn-dashboard"><i class="las la-plus"></i>Create new Collection</button>
          </a>
        </div>
        <!--        <div class="filter-row filter-row1">-->
        <!--          <div class="form-label show">Sort by :</div>-->
        <!--          <div class="select-wrapper-sm">-->
        <!--            <select class="form-control border-0 input-sm" [(ngModel)]="sort" (change)="changed()">-->
        <!--              <option selected="true" value="select">&#45;&#45;select&#45;&#45;</option>-->
        <!--              <option value="name">Name</option>-->
      <!--            </select>-->
    <!--          </div>-->
  <!--        </div>-->
</div>
</div>
</div>
<div class="row section1">
  <div class="col-12">
    <div class="table-responsive applicants-details overflow-x-visible">
      <table class="table table-bordered user-table">
        <thead>
          <tr>
            <th scope="col">ID</th>
            <th scope="col">Icon</th>
            <th scope="col">Title</th>
            <th scope="col">Description</th>
            <th scope="col">Entity</th>
            <th scope="col">Status</th>
            <th scope="col">Created At</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        @if (!loading && !!collections?.length) {
          <tbody>
            @for (c of collections; track c; let i = $index) {
              <tr class="client">
                <td class="text-nowrap" [attr.title]="(c.id || '').toUpperCase()"><span>{{(c.id || '').slice(-6).toUpperCase()}}</span>
                <i (click)="handleCopyToClipboard(c.id);" class="las la-copy la-lg pointer copy-icon"></i>
              </td>
              <td><img [src]="c.thumbnail" alt="" width="50"></td>
              <td>{{c.title}}</td>
              <td>{{ c.description }}</td>
              <td class="text-nowrap">{{c.entity}}
                <i (click)="handleCopyToClipboard(c.entity);" class="las la-copy la-lg pointer copy-icon"></i>
              </td>
              <td [ngClass]="c.status == 1 ? 'text-success' : 'text-danger'">{{ c.status == 1 ? 'Enabled' : 'Disabled' }}</td>
              <td>{{ c.createdAt | date }}</td>
              <td class="action">
                <div class="dropdown">
                  <button type="button" class="btn header-item waves-effect btn-dropdown" id="page-header-user-dropdown"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                    <a class="   mr-3 text-primary py-2 text-nowrap">
                      View actions <i class="las mb-1 la-angle-down align-middle mr-0"></i></a>
                    </button>
                    <div class="dropdown-menu dropdown-menu-right animate slideIn side-menu-dropdown py-0 rounded-1">
                      <a class=" dropdown-item  text-primary border-bottom py-2 text-nowrap"
                        [routerLink]="['/nfts/single-collection/', c.id]">
                        <i class="las la-eye mb-1 la-lg  align-middle mr-0"></i> View</a>
                        <a class=" dropdown-item  border-bottom py-2 text-nowrap"
                          [ngClass]="c.status ? 'text-danger' : 'text-success'"
                          (click)="toggleCollection(c.id)">
                          <i class="las mb-1 la-lg align-middle mr-0"
                          [ngClass]="c.status ? 'la-times' : 'la-check'"></i>
                        {{c.status ? 'Disable' : 'Enable'}}</a>
                      </div>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          }
          @if (loading) {
            <tbody>
              @for (q of loaders; track q; let qi = $index) {
                <tr class="client">
                  <td>
                    <ngx-skeleton-loader [theme]="{width:'200px', marginBottom: '0px'}"></ngx-skeleton-loader>
                  </td>
                  <td>
                    <ngx-skeleton-loader
                    [theme]="{ width:'50px',height:'50px', marginBottom: '0px'}"></ngx-skeleton-loader>
                  </td>
                  <td>
                    <ngx-skeleton-loader [theme]="{width:'150px', marginBottom: '0px'}"></ngx-skeleton-loader>
                  </td>
                  <td>
                    <ngx-skeleton-loader [theme]="{ width:'200px', marginBottom: '0px'}"></ngx-skeleton-loader>
                  </td>
                  <td>
                    <ngx-skeleton-loader [theme]="{width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
                  </td>
                  <td>
                    <ngx-skeleton-loader [theme]="{width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
                  </td>
                  <td>
                    <ngx-skeleton-loader [theme]="{width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
                  </td>
                  <td>
                    <ngx-skeleton-loader [theme]="{width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
                  </td>
                </tr>
              }
            </tbody>
          }
        </table>
        @if (!loading && !collections?.length) {
          <div class="d-flex align-items-center justify-content-center py-5">
            No collections found
          </div>
        }
      </div>
    </div>
  </div>
</div>
